import { BaseDb } from "common/BaseDb"
import { AttachmentsSchema } from "components/attachments/attachments.schema"

class AttachmentsDb extends BaseDb<AttachmentsSchema> {}

const attachmentsDb = new AttachmentsDb("attachments")
export default attachmentsDb
